module.exports = __webpack_public_path__ + "img/windows-icon.1cb314ad.png";